var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__content d-flex flex-column"},[_c('add-tasks'),_c('tasks-view'),(_vm.isTaskDetailsOpen)?_c('task-details-popup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }